import React, { FunctionComponent } from 'react';
import { Text, View, StyleSheet } from 'react-native';
import { AreaCategory } from 'fitbeat.gym-core';
import moment from 'moment-timezone';
import { defaultScale } from '../../utils/scaling';
import Theme from '../../theme';
import { TranslateProp } from '../../common-types';
import { buildSessionTimingArray, getAreaDisplayName } from '../../utils/areaCategoryMapping';

interface IProps {
  t: TranslateProp;
  areaCategory: AreaCategory;
  startTime: Date | number;
  endTime: Date | number;
}

const SessionTimings: FunctionComponent<IProps> = ({
  t,
  areaCategory,
  startTime,
  endTime,
}) => {
  const momentStartTime = moment(startTime);
  const momentEndTime = moment(endTime);

  const sessionTimings: { timestamp: string, description: string }[] = [];

  for (let i = 0; i <= 5; i++) {
    sessionTimings.push(buildSessionTimingArray(t, i, momentStartTime, momentEndTime, areaCategory));
  }

  const areaDisplayName = getAreaDisplayName(areaCategory);

  return (
    <View style={styles.container}>
      <Text style={styles.heading}>{t('yourAreaSession', { areaCategory: areaDisplayName })}</Text>
      {sessionTimings.map((timing) => (
        <View style={styles.timings}>
          <Text style={styles.time}>{timing.timestamp}</Text>
          <Text style={styles.description}>{timing.description}</Text>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: defaultScale(20),
    backgroundColor: Theme.WHITE,
    marginTop: defaultScale(10),
  },
  heading: {
    ...Theme.textStyle.heading2,
    marginBottom: defaultScale(20),
  },
  timings: {
    flex: 4,
    display: 'flex',
    flexDirection: 'row',
    marginVertical: defaultScale(10),
  },
  time: {
    ...Theme.textStyle.bodyCopyBold,
    marginRight: defaultScale(15),
    flex: 0.5,
    color: Theme.GREY_DARK_MEDIUM_DARK,
  },
  description: {
    ...Theme.textStyle.bodyCopyReg,
    flex: 3,
    color: Theme.GREY_DARK_MEDIUM_DARK,
  },
});

export default SessionTimings;
